<template>
  <div>
    <nav-breadcrumb :menu="[{label: '编辑客户账号信息'}]"/>
    <form-build
      form-name="form"
      :form-columns="formColumns"
      :form-rules="formRules"
      :form-data="form"
      :form-buttons="formButtons"
    ></form-build>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'

  export default {
    name: "ConfigDebtorUserEdit",
    data() {
      return {
        customerListOptions: [],
        form: {
          c__customerId: '',
          u__userId: '',
          u__userCode: '',
          u__userName: '',
          u__telephone: '',
          u__email: '',
          u__password: '',
          u__passwordExpiryDate: '',
          u__passwordExpiryDate__dateformat: '',
          u__disabled: 'N'

        },
        formRules: {
          c__customerId: [
            {
              required: true,
              message: '此项目必填！'
            }
          ],
          u__userName: [
            {
              required: true,
              message: '此项目必填！'
            }
          ],
          u__userCode: [
            {
              required: true,
              message: '此项目必填！'
            }
          ],
        },
        formButtons: [
          {
            label: '确认',
            type: 'primary',
            clickHandler:$refs=>{
              this.onSubmit($refs)
            }
          },
          {
            label: '取消',
            // type: 'primary',
            clickHandler: $refs=>{
              this.$router.back()
            }
          }
        ],
        userId: this.$route.query['u.userId']||''
      }
    },
    mounted() {
      this.getCustomerList()

      if( this.userId ) {
        this.getCustomerUserDetail( this.userId )
      }
    },
    computed: {
      formColumns: function () {
        return [
          {
            label: '用户名',
            component: 'el-input',
            field: 'u__userCode'
          },
          {
            label: '客户名称',
            component: 'el-select',
            field: 'c__customerId',
            options: this.customerListOptions
          },
          {
            label: '姓名',
            component: 'el-input',
            field: 'u__userName'
          },
          {
            label: '密码',
            component: 'el-input',
            field: 'u__password',
            placeholder: '留空则不修改密码'
          },
          {
            label: '手机号',
            component: 'el-input',
            field: 'u__telephone'
          },
          {
            label: '邮箱',
            component: 'el-input',
            field: 'u__email'
          },
          {
            label: '状态',
            component: 'el-select',
            field: 'u__disabled',
            options: [
              {
                label: '启用',
                value: 'N'
              },
              {
                label: '禁用',
                value: 'Y'
              }
            ]
          }
        ]
      }
    },
    methods: {
      onSubmit: function ($refs) {
        $refs.validate(valid=> {
          if(valid) {
            xhr.updateCustomerUser(this.form, res=> {
              try{
                if(res.data.status == 'success') {
                  let userId = res.data.rflag['u.userId']
                  $refs.resetFields()
                  this.$router.push({
                    name: 'CustomerAdminCustomerUserList'
                  })
                }
              }catch(e){}
            })
          }
        })
      },
      getCustomerUserDetail: function (userId) {
        xhr.getCustomerUserList(
          {
            'xlist.search.u.userId': userId,
            'xlist.search.u.userId.op': 'eq'
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.form = res.data.data.shift()
              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerList: function () {
        xhr.getCustomerList({}, res=> {
          try {
            if(res.data.status == 'success' && res.data.data) {
              this.customerListOptions = res.data.data.map(item=>{
                return {
                  label: item.c__customerName,
                  value: item.c__customerId
                }
              })
            }
          }catch (e) {

          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerUserEdit.vue